import { useState } from 'react'

/**
 * The {@link useConstant} hook creates a value which is initialized during
 * component initialization and is not changed during component life.
 *
 * @template {*} TValue
 *
 * @example
 * ```
 *  const resizeObserver = useConstant(() => new ResizeObserver(() => {
 *    // do something
 *  }))
 * ```
 *
 * @param {() => TValue} init
 *
 * @returns {TValue}
 */
export function useConstant(init) {
  const [value] = useState(init)

  return value
}
